import { render } from "./proposalDecision.vue?vue&type=template&id=38eb881e&scoped=true"
import script from "./proposalDecision.vue?vue&type=script&lang=js"
export * from "./proposalDecision.vue?vue&type=script&lang=js"

import "./proposalDecision.vue?vue&type=style&index=0&id=38eb881e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38eb881e"]])

export default __exports__